module.exports = __webpack_public_path__ + "static/media/mic_off.49d9d9ab.svg";